<template>
  <div class="fl lmnr11  col-md-3 d-none d-md-block">
    <div class="lmnrdh1">
      <div class="tit3 w100"><a :href="'/nav/list/'+pNavs.id">{{ pNavs.name }}</a></div>
      <ul class="gsjj0">
        <li v-for="item in navs" :key="item.id">
          <a v-if="item.id ===currentNav[0].id" :href="'/nav/list/'+item.id" class="thisclass">{{ item.name }}</a>
          <a v-else :href="'/nav/list/'+item.id">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <ContactUs />
    <div class="clear"></div>
  </div>
</template>
<script>
import ContactUs from "@/components/ContactUs"
import {getNavs} from "@/api/home"
export default {
  props:{
    initNavId:{
      type:Number,
      default:0
    }
  },
  watch:{
    initNavId(n){
      this.nid = n
      this.getData()
    }
  },
  components:{ContactUs},
  data(){
    return {
      nid:this.$route.params.nid??this.initNavId,
      currentNav:[],
      navs:[],
      pNavs:{},
    }
  },
  created() {
    this.getData()
  },
  methods:{
    getData(){
      if(this.nid){
        const promise = []
        promise.push(new Promise((resolve)=>{
          const temp1 = {id:this.nid}
          getNavs(temp1).then((response)=>{
            this.currentNav = response
            resolve()
          })
        }))

        Promise.all([...promise]).then(()=>{
          let temp2
          this.$emit('articleNav', this.currentNav[0])
          if(this.currentNav[0]['parent_id']!==0){
            temp2 = {parent_id:this.currentNav[0]['parent_id']}
            const temp3 = {id:this.currentNav[0]['parent_id']}
            getNavs(temp3).then((response)=>{
              this.pNavs = response[0]
            })
            //temp4 = this.currentNav[0]
            //this.$emit('articleNav', temp4)
          }else{
            temp2 = {parent_id:this.nid}
            this.pNavs = this.currentNav[0]
          }
          getNavs(temp2).then((response)=>{
            this.navs = response
           // temp4 = response[0]
            //this.$emit('articleNav', temp4)
          })
        })
      }
    }
  }
}
</script>